let tokenRef = null;
const setTokenRef = value => {
  tokenRef = value;
};
export const getComponentToken = () => ({
  sizingVoucherImage: tokenRef?.root.sizingVoucherSm,
  sizingVoucherImageLg: tokenRef?.root.sizingVoucherMd,
  sizingVoucherHeight: tokenRef?.root.sizingVoucherSm,
  sizingVoucherHeightLg: tokenRef?.root.sizingVoucherMd,
  sizingVoucherIcon: tokenRef?.root.sizingIconGeneralXs,
  sizingVoucherIconLg: tokenRef?.root.sizingIconGeneralSm,
  sizingRibbonIconBackground: tokenRef?.root.sizingIconGeneralLg,
  sizingRibbonIcon: tokenRef?.root.sizingIconGeneralSm,
  sizingDrawerImageFlag: tokenRef?.root.sizingImageXxs,
  sizingDrawerImageThumbnail: tokenRef?.root.sizingImageLg,
  sizingDrawerHandle: tokenRef?.root.sizingIconGeneralXl,
  sizingInputIcon: tokenRef?.root.sizingIconUtilityXs,
  sizingInputIconLg: tokenRef?.root.sizingIconGeneralSm,
  sizingInputIconUtilityLg: tokenRef?.root.sizingIconGeneralSm,
  sizingInputThumbnail: tokenRef?.root.sizingImageSm,
  sizingInputIconUtility: tokenRef?.root.sizingIconUtilityXs,
  sizingInputImageFlag: tokenRef?.root.sizingImageXxs,
  sizingInputImageFlagLg: tokenRef?.root.sizingImageXs,
  sizingSearchInputIcon: tokenRef?.root.sizingIconUtilityXs,
  sizingSearchInputIconLg: tokenRef?.root.sizingIconGeneralSm,
  sizingSelectorThumbnail: tokenRef?.root.sizingImageSm,
  sizingSelectorVariant6Thumbnail: tokenRef?.root.sizingImageMd,
  sizingToastIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingToastTextHeight: tokenRef?.root.sizingTextBoxSm,
  sizingTextLinkIconLeft: tokenRef?.root.sizingIconGeneralSm,
  sizingTextLinkIconRight: tokenRef?.root.sizingIconUtilityXs,
  sizingTextLinkIconRightLg: tokenRef?.root.sizingIconUtilityXs2,
  sizingTagShort: tokenRef?.root.sizingTagSm,
  sizingTagTall: tokenRef?.root.sizingTagMd,
  sizingTagTallLg: tokenRef?.root.sizingTagLg,
  sizingTabsIcon: tokenRef?.root.sizingIconGeneralSm,
  sizingStepperInner: tokenRef?.root.sizingIconGeneralSm,
  sizingStepperOuter: tokenRef?.root.sizingIconGeneralMd,
  sizingStepperOuterLg: tokenRef?.root.sizingIconGeneralLg,
  sizingStepperInnerLg: tokenRef?.root.sizingIconGeneralMd,
  sizingPaginationIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingPaginationIconXs: tokenRef?.root.sizingIconUtilityXs,
  sizingPaginationBackground: tokenRef?.root.sizingIconGeneralMd,
  sizingPaginationBackgroundLg: tokenRef?.root.sizingIconGeneralLg,
  sizingNotificationIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingBottomNavigationIcon: tokenRef?.root.sizingIconGeneralSm,
  sizingModalIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingLocationPinDefault: tokenRef?.root.sizingIconUtilitySm,
  sizingLocationPinActive: tokenRef?.root.sizingIconUtilityLg,
  sizingButtonIcon: tokenRef?.root.sizingIconGeneralSm,
  sizingListItemIconImage: tokenRef?.root.sizingImageMd,
  sizingListItemIconIcon: tokenRef?.root.sizingIconGeneralMd,
  sizingListItemIconIconStatus: tokenRef?.root.sizingIconGeneralSm,
  sizingListItemImageImage: tokenRef?.root.sizingImageXxl,
  sizingListItemImageIcon: tokenRef?.root.sizingIconGeneralXs,
  sizingListItemImageIconLg: tokenRef?.root.sizingIconGeneralXs2,
  sizingListItemImageThumbnail: tokenRef?.root.sizingImageLg,
  sizingListItemIcon: tokenRef?.root.sizingIconUtilityXs,
  sizingListItemIconLg: tokenRef?.root.sizingIconUtilitySm,
  sizingCirclePatternVariant1: tokenRef?.root.sizingCirclePatternMd,
  sizingCirclePatternVariant1Lg: tokenRef?.root.sizingCirclePatternLg,
  sizingCirclePatternVariant2: tokenRef?.root.sizingCirclePatternXs,
  sizingCirclePatternVariant2Lg: tokenRef?.root.sizingCirclePatternSm,
  sizingCarouselIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingCarouselIconBackground: tokenRef?.root.sizingIconUtilityLg,
  sizingBannerIcon: tokenRef?.root.sizingIconSpotXs,
  sizingBannerIconLg: tokenRef?.root.sizingIconSpotLg,
  sizingBulletListIcon: tokenRef?.root.sizingBullet,
  sizingBulletListIconSm: tokenRef?.root.sizingBulletSm,
  sizingAccordionIcon: tokenRef?.root.sizingIconUtilityXs,
  sizingAccordionIconLg: tokenRef?.root.sizingIconUtilitySm,
  sizingCardIconSubtitle: tokenRef?.root.sizingIconGeneralXs,
  sizingCardIconSubtitleLg: tokenRef?.root.sizingIconGeneralXs2,
  sizingCardIconTitle: tokenRef?.root.sizingIconGeneralXs,
  sizingCardIconTitleLg: tokenRef?.root.sizingIconGeneralSm,
  sizingCardThumbnailMd: tokenRef?.root.sizingImageMd,
  sizingCardThumbnailLg: tokenRef?.root.sizingImageLg,
  sizingCardThumbnailXl: tokenRef?.root.sizingImageXl,
  sizingCardColorListSm: tokenRef?.root.sizingColorList,
  sizingCalendarDate: tokenRef?.root.sizingTextBoxXs,
  sizingCalendarDay: tokenRef?.root.sizingTextBoxXs,
  sizingChipIconClose: tokenRef?.root.sizingIconUtilityXxs,
  sizingIconButtonIconMedium: tokenRef?.root.sizingIconGeneralSm,
  sizingIconButtonIconSmall: tokenRef?.root.sizingIconGeneralXs,
  sizingDateTimePickerDate: tokenRef?.root.sizingTextBoxXs,
  sizingDateTimePickerIcon: tokenRef?.root.sizingIconUtilitySm,
  sizingDateTimePickerIconXs: tokenRef?.root.sizingIconUtilityXs,
  sizingDateTimePickerDay: tokenRef?.root.sizingTextBoxXs,
  sizingDateTimePickerTimeXs: tokenRef?.root.sizingTextBoxXs,
  sizingDateTimePickerTime: tokenRef?.root.sizingTextBoxLg,
  sizingDateTimePickerDayXs: tokenRef?.root.sizingTextBoxXxs,
  spacingVoucherListViewTextPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingVoucherListViewTextVerticalGap: tokenRef?.root.spacingTextXs,
  spacingVoucherListViewTextPointsPaddingLeft: tokenRef?.root.spacingTextXs,
  spacingVoucherListViewNoImageTextPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingVoucherListViewNoImageTextVerticalGap: tokenRef?.root.spacingTextXs,
  spacingVoucherListViewNoImageCheckboxPaddingHorizontal: tokenRef?.root.spacingGapXxl,
  spacingRibbonHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingVoucherGridViewPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingVoucherGridViewPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingVoucherGridViewTextVerticalGap: tokenRef?.root.spacingTextXs,
  spacingVoucherGridViewTextHorizontalGap: tokenRef?.root.spacingTextXs,
  spacingVoucherGridViewLabelPaddingBottom: tokenRef?.root.spacingTextMd,
  spacingVoucherGridViewLabelPaddingTop: tokenRef?.root.spacingTextXs,
  spacingDrawerPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingDrawerPaddingBottom: tokenRef?.root.spacingGapLg,
  spacingDrawerPaddingTop: tokenRef?.root.spacingGapLg,
  spacingDrawerVerticalGap: tokenRef?.root.spacingGapMd,
  spacingDrawerListOptionPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingDrawerListOptionPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingDrawerListOptionHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingDrawerListVerticalGap: tokenRef?.root.spacingGapSm,
  spacingDrawerImageFlagPaddingRight: tokenRef?.root.spacingGapSm,
  spacingDrawerImageThumbnailPaddingRight: tokenRef?.root.spacingGapMd,
  spacingDrawerHeaderPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingDrawerHeaderPaddingTop: tokenRef?.root.spacingGapLg,
  spacingDrawerSearchPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingDrawerLabelPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingDrawerLabelPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingDrawerHandlePaddingTop: tokenRef?.root.spacingGapSm,
  spacingDrawerHandlePaddingBottom: tokenRef?.root.spacingGapLg,
  spacingDrawerChipGroupVerticalGap: tokenRef?.root.spacingGapMd,
  spacingDrawerChipGroupHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingDrawerChipVerticalGap: tokenRef?.root.spacingGapMd,
  spacingDrawerChipPaddingBottom: tokenRef?.root.spacingGapSm,
  spacingStickyFooterPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingStickyFooterPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingStickyFooterPaddingBottom: tokenRef?.root.spacingGapLg,
  spacingStickyFooterPaddingTop: tokenRef?.root.spacingGapMd,
  spacingStickyFooterHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingStickyFooterVerticalGap: tokenRef?.root.spacingGapSm,
  spacingStickyFooterTextLinkVerticalGap: tokenRef?.root.spacingGapMd,
  spacingInputPaddingVertical: tokenRef?.root.spacingInputMd2,
  spacingInputPaddingVerticalLg: tokenRef?.root.spacingInputMd3,
  spacingInputPaddingVerticalActive: tokenRef?.root.spacingInputSm2,
  spacingInputPaddingVerticalLgActive: tokenRef?.root.spacingInputSm3,
  spacingInputPaddingHorizontal: tokenRef?.root.spacingInputMd,
  spacingInputVerticalGap: tokenRef?.root.spacingGapSm,
  spacingInputHorizontalGap: tokenRef?.root.spacingTextSm,
  spacingInputTextHintMessagePaddingTop: tokenRef?.root.spacingTextXs,
  spacingInputTextCounterPaddingTop: tokenRef?.root.spacingTextXs,
  spacingInputTextCounterPaddingLeft: tokenRef?.root.spacingTextMd,
  spacingInputTextLabelPaddingRight: tokenRef?.root.spacingTextMd,
  spacingInputTextPointsPaddingHorizontal: tokenRef?.root.spacingTextMd,
  spacingInputTextLinkPaddingLeft: tokenRef?.root.spacingTextMd,
  spacingInputTextNumberPaddingHorizontal: tokenRef?.root.spacingTextMd,
  spacingInputThumbnailPaddingLeft: tokenRef?.root.spacingIconMd,
  spacingInputIconPaddingLeft: tokenRef?.root.spacingIconMd,
  spacingInputIconPaddingRight: tokenRef?.root.spacingGapSm,
  spacingInputListOptionsPaddingHorizontal: tokenRef?.root.spacingInputMd,
  spacingInputListOptionsPaddingVertical: tokenRef?.root.spacingInputSm,
  spacingInputListOptionsHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingInputListOptionsVerticalGap: tokenRef?.root.spacingInputMd,
  spacingInputOptionsPaddingVertical: tokenRef?.root.spacingInputSm,
  spacingInputImageFlagPaddingRight: tokenRef?.root.spacingInputSm,
  spacingSearchInputPaddingVertical: tokenRef?.root.spacingInputSm2,
  spacingSearchInputPaddingVerticalLg: tokenRef?.root.spacingInputSm3,
  spacingSearchInputVerticalGap: tokenRef?.root.spacingGapSm,
  spacingSearchInputPaddingHorizontal: tokenRef?.root.spacingInputMd,
  spacingSearchInputIconPaddingRight: tokenRef?.root.spacingGapSm,
  spacingSearchInputIconPaddingLeft: tokenRef?.root.spacingGapMd,
  spacingSearchInputResultLabelPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingSearchInputResultListPaddingLeft: tokenRef?.root.spacingGapXxl,
  spacingSearchInputResultListPaddingRight: tokenRef?.root.spacingGapMd,
  spacingSearchInputResultPaddingVertical: tokenRef?.root.spacingInputSm,
  spacingFileInputTextLabelPaddingBottom: tokenRef?.root.spacingInputXs,
  spacingFileInputTextVerticalGap: tokenRef?.root.spacingInputSm,
  spacingFileInputTextLinkPaddingBottom: tokenRef?.root.spacingInputXs,
  spacingFileInputTextLinkPaddingLeft: tokenRef?.root.spacingInputMd,
  spacingRatingIconHorizontalGap: tokenRef?.root.spacingIconXs,
  spacingRatingHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingSelectorPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingSelectorPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingSelectorVerticalGap: tokenRef?.root.spacingGapMd,
  spacingSelectorHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingSelectorVariant6PaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingSelectorVariant6VerticalGap: tokenRef?.root.spacingGapXs,
  spacingSelectorVariant6SubtitlePaddingTop: tokenRef?.root.spacingTextXs,
  spacingSelectorThumbnailPaddingLeft: tokenRef?.root.spacingIconMd,
  spacingSelectorVariant7PaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingSelectorTextUnavailablePaddingTop: tokenRef?.root.spacingTextXs,
  spacingSelectorTextSubtitlePaddingTop: tokenRef?.root.spacingTextXs,
  spacingSelectorTextPointsPaddingLeft: tokenRef?.root.spacingTextMd,
  spacingSelectorTextTagPaddingLeft: tokenRef?.root.spacingTextSm,
  spacingToastHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingToastPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingToastPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingToastPaddingHorizontalLg: tokenRef?.root.spacingGapLg,
  spacingToastPaddingVerticalLg: tokenRef?.root.spacingGapLg,
  spacingTextLinkHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingTagPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingTabsVerticalGap: tokenRef?.root.spacingGapSm,
  spacingTabsPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingTabsIconVerticalGap: tokenRef?.root.spacingIconXs,
  spacingTablePaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingTablePaddingHorizontalLg: tokenRef?.root.spacingGapLg,
  spacingTableCellPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingTableCellPaddingVerticalLg: tokenRef?.root.spacingGapLg,
  spacingTableCellHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingPaginationHorizontalGapSm: tokenRef?.root.spacingGapMd,
  spacingPaginationHorizontalGapLg: tokenRef?.root.spacingGapLg,
  spacingPaginationIconPaddingHorizontal: tokenRef?.root.spacingGapSm2,
  spacingPaginationIconPaddingHorizontalLg: tokenRef?.root.spacingGapSm,
  spacingPaginationIconHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingPaginationIconHorizontalGapLg: tokenRef?.root.spacingGapSm,
  spacingPaginationIconPaddingVertical: tokenRef?.root.spacingGapSm2,
  spacingPaginationIconPaddingVerticalLg: tokenRef?.root.spacingGapSm,
  spacingPaginationTextInputHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingNumberedListHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingNumberedListHorizontalGapXs: tokenRef?.root.spacingGapXs,
  spacingNumberedListVerticalGap: tokenRef?.root.spacingGapSm,
  spacingNotificationPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingNotificationPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingNotificationVerticalGap: tokenRef?.root.spacingGapSm,
  spacingNotificationHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingNotificationPaddingHorizontalLg: tokenRef?.root.spacingGapLg,
  spacingNotificationPaddingVerticalLg: tokenRef?.root.spacingGapLg,
  spacingNotificationTextLinkPaddingTop: tokenRef?.root.spacingTextSm,
  spacingTopNavigationPaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingTopNavigationPaddingBottom: tokenRef?.root.spacingGapSm,
  spacingTopNavigationHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingTopNavigationIconButtonHorizontalGap: tokenRef?.root.spacingIconSm,
  spacingTopNavigationTextLinkPaddingRight: tokenRef?.root.spacingIconSm,
  spacingTopNavigationTitlePaddingVertical: tokenRef?.root.spacingIconSm,
  spacingBottomNavigationPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingBottomNavigationPaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingModalPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingModalCardVerticalGap: tokenRef?.root.spacingGapMd,
  spacingModalCardPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingModalCardPaddingTop: tokenRef?.root.spacingGapLg,
  spacingModalCardPaddingBottom: tokenRef?.root.spacingGapXl,
  spacingModalCardPaddingHorizontalLg: tokenRef?.root.spacingGapXl,
  spacingModalCardPaddingHorizontalSm: tokenRef?.root.spacingGapXl,
  spacingModalCardPaddingTopLg: tokenRef?.root.spacingGapXl,
  spacingModalCardPaddingTopSm: tokenRef?.root.spacingGapXl,
  spacingModalCardPaddingBottomLg: tokenRef?.root.spacingGapXxl,
  spacingModalCardPaddingBottomSm: tokenRef?.root.spacingGapXxl,
  spacingModalIconPaddingLeft: tokenRef?.root.spacingIconMd,
  spacingModalButtonPaddingTop: tokenRef?.root.spacingGapSm,
  spacingModalButtonStickyPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingModalButtonStickyPaddingVertical: tokenRef?.root.spacingGapLg,
  spacingButtonIconPaddingVerticalLg: tokenRef?.root.spacingIconXxs,
  spacingButtonPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingButtonPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingButtonMiniPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingButtonMiniPaddingVertical: tokenRef?.root.spacingGapXs,
  spacingDividerHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingListItemTextPaddingHorizontal: tokenRef?.root.spacingTextMd,
  spacingListItemIconStatusPaddingRight: tokenRef?.root.spacingGapMd,
  spacingListItemLinkPaddingRight: tokenRef?.root.spacingGapMd,
  spacingListItemTogglePaddingRight: tokenRef?.root.spacingGapMd,
  spacingListItemButtonPaddingLeft: tokenRef?.root.spacingGapSm,
  spacingListItemIconPaddingLeft: tokenRef?.root.spacingIconSm,
  spacingListItemImagePaddingRight: tokenRef?.root.spacingImageMd,
  spacingListItemIconImagePaddingVertical: tokenRef?.root.spacingImageMd,
  spacingListItemIconImagePaddingHorizontal: tokenRef?.root.spacingImageMd,
  spacingListItemIconIconPaddingVertical: tokenRef?.root.spacingIconLg,
  spacingListItemIconIconPaddingHorizontal: tokenRef?.root.spacingIconLg,
  spacingListItemImageIconPaddingRight: tokenRef?.root.spacingIconXs,
  spacingListItemImagePointsPaddingTop: tokenRef?.root.spacingIconXs,
  spacingHeroBannerIndicatorPaddingBottom: tokenRef?.root.spacingGapMd,
  spacingHeroBannerIndicatorHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingHeroBannerTextPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingCirclePatternVariant1TextPaddingTop: tokenRef?.root.spacingTextMd,
  spacingCirclePatternVariant1VerticalGap: tokenRef?.root.spacingGapXxl,
  spacingCirclePatternVariant2TextPaddingLeft: tokenRef?.root.spacingTextMd,
  spacingCirclePatternVariant2VerticalGap: tokenRef?.root.spacingGapLg,
  spacingCirclePatternVariant2VerticalGapLg: tokenRef?.root.spacingGapXl,
  spacingCirclePatternVariant2HorizontalGapLg: tokenRef?.root.spacingGapXxxl,
  spacingCarouselIndicatorPaddingTop: tokenRef?.root.spacingGapSm,
  spacingCarouselIndicatorHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingCarouselIndicatorPaddingTopLg: tokenRef?.root.spacingGapMd,
  spacingCarouselPaddingTop: tokenRef?.root.spacingGapXxl,
  spacingCarouselPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingCarouselPaddingHorizontalLg: tokenRef?.root.spacingGapXl,
  spacingCarouselTextVerticalGap: tokenRef?.root.spacingGapMd,
  spacingBannerPaddingTop: tokenRef?.root.spacingGapXl,
  spacingBannerPaddingBottom: tokenRef?.root.spacingGapXl,
  spacingBannerPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingBannerVerticalGap: tokenRef?.root.spacingGapSm,
  spacingBannerVerticalGapLg: tokenRef?.root.spacingGapMd,
  spacingBannerButtonPaddingTop: tokenRef?.root.spacingGapSm,
  spacingBreadcrumbsHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingBreadcrumbsDividerPaddingRight: tokenRef?.root.spacingGapSm,
  spacingBulletListHorizontalGapSm: tokenRef?.root.spacingGapSm,
  spacingBulletListHorizontalGap: tokenRef?.root.spacingGapSm2,
  spacingBulletListPaddingLeft: tokenRef?.root.spacingGapSm,
  spacingBulletListVerticalGap: tokenRef?.root.spacingGapSm,
  spacingBulletListIconPaddingTopXs: tokenRef?.root.spacingBulletXs,
  spacingBulletListIconPaddingTopSm: tokenRef?.root.spacingBulletSm,
  spacingBulletListIconPaddingTopMd: tokenRef?.root.spacingBulletMd,
  spacingAccordionHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingAccordionTitlePaddingVertical: tokenRef?.root.spacingTextMd,
  spacingAccordionBodyPaddingBottom: tokenRef?.root.spacingTextMd,
  spacingAccordionIconPaddingTop: tokenRef?.root.spacingIconXs,
  spacingCardTitleImagePaddingRight: tokenRef?.root.spacingGapMd,
  spacingCardPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingCardPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingCardPaddingBottom: tokenRef?.root.spacingGapMd,
  spacingCardButtonPaddingLeft: tokenRef?.root.spacingGapMd,
  spacingCardTagPaddingBottom: tokenRef?.root.spacingGapSm,
  spacingCardTitleVerticalGap: tokenRef?.root.spacingGapSm,
  spacingCardTitleHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingCardTitleHorizontalGapXs: tokenRef?.root.spacingGapXs,
  spacingCalendarMonthPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingCalendarMonthPaddingBottomLg: tokenRef?.root.spacingGapSm,
  spacingCalendarDayPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingCalendarPaddingVerticalLg: tokenRef?.root.spacingGapMd,
  spacingCalendarPaddingHorizontalLg: tokenRef?.root.spacingGapMd,
  spacingCalendarPaddingHorizontal: tokenRef?.root.spacingGapLg,
  spacingCalendarDatesVerticalGap: tokenRef?.root.spacingGapSm,
  spacingCalendarButtonPaddingLeft: tokenRef?.root.spacingGapLg,
  spacingChipPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingChipPaddingVertical: tokenRef?.root.spacingGapXs,
  spacingChipTextLinkPaddingVertical: tokenRef?.root.spacingGapXs,
  spacingChipTextLinkPaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingIconButtonPaddingHorizontal: tokenRef?.root.spacingGapSm,
  spacingIconButtonHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingIconButtonPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingIconButtonPaddingHorizontalSm: tokenRef?.root.spacingGapXs,
  spacingIconButtonHorizontalGapSm: tokenRef?.root.spacingGapMd,
  spacingIconButtonPaddingVerticalSm: tokenRef?.root.spacingGapXs,
  spacingCardIconListHorizontalGap: tokenRef?.root.spacingGapSm,
  spacingCardFooterVerticalGap: tokenRef?.root.spacingGapMd,
  spacingCardFooterHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingCardBodyVerticalGap: tokenRef?.root.spacingGapSm,
  spacingSwimlaneHorizontalGapSm: tokenRef?.root.spacingGapSm,
  spacingSwimlaneHorizontalGapMd: tokenRef?.root.spacingGapMd,
  spacingDateTimePickerMonthPaddingBottom: tokenRef?.root.spacingGapSm,
  spacingDateTimePickerPaddingTop: tokenRef?.root.spacingGapMd,
  spacingDateTimePickerPaddingBottom: tokenRef?.root.spacingGapMd,
  spacingDateTimePickerPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingDateTimePickerVerticalGap: tokenRef?.root.spacingGapMd,
  spacingDateTimePickerButtonPaddingLeft: tokenRef?.root.spacingGapLg,
  spacingDateTimePickerTimePaddingVertical: tokenRef?.root.spacingGapSm,
  spacingDateTimePickerTimePaddingBottom: tokenRef?.root.spacingGapSm,
  spacingDateTimePickerYearPaddingVertical: tokenRef?.root.spacingGapSm,
  spacingRadioInputVerticalGap: tokenRef?.root.spacingGapMd,
  spacingRadioInputHorizontalGap: tokenRef?.root.spacingGapMd,
  spacingCardColorListHorizontalGap: tokenRef?.root.spacingGapXs,
  spacingCoachmarkVerticalGap: tokenRef?.root.spacingGapSm,
  spacingCoachmarkPaddingHorizontal: tokenRef?.root.spacingGapMd,
  spacingCoachmarkPaddingVertical: tokenRef?.root.spacingGapMd,
  spacingCoachmarkIndicatorPaddingLeft: tokenRef?.root.spacingGapSm2,
  spacingCoachmarkIndicatorPaddingRight: tokenRef?.root.spacingGapSm2,
  colorVoucherBackground: tokenRef?.root.colorBackgroundStandard,
  colorVoucherBackgroundRedeemed: tokenRef?.root.colorBackgroundDisabled,
  colorVoucherTextTitle: tokenRef?.root.colorTextNeutral,
  colorVoucherTextSubtitle: tokenRef?.root.colorTextSubtle,
  colorVoucherTextPoints: tokenRef?.root.colorTextNeutral,
  colorVoucherTextPointsRedeemed: tokenRef?.root.colorTextSubtle,
  colorVoucherTextTitleRedeemed: tokenRef?.root.colorTextNeutral,
  colorVoucherTextSubtitleRedeemed: tokenRef?.root.colorTextSubtle,
  colorVoucherTextSubtitleExpiring: tokenRef?.root.colorTextAlert,
  colorVoucherTextPointsStrikethrough: tokenRef?.root.colorTextStrikethrough,
  colorVoucherIcon: tokenRef?.root.colorIconSubtle,
  colorRibbonIconBackgroundPrimary: tokenRef?.root.colorRibbonPrimary2,
  colorRibbonIconBackgroundSecondary: tokenRef?.root.colorRibbonSecondary2,
  colorRibbonIconPrimary: tokenRef?.root.colorRibbonPrimary3,
  colorRibbonIconSecondary: tokenRef?.root.colorRibbonSecondary,
  colorRibbonTextPrimary: tokenRef?.root.colorRibbonPrimary,
  colorRibbonTextPrimaryDark: tokenRef?.root.colorRibbonPrimaryDark,
  colorRibbonTextSecondary: tokenRef?.root.colorRibbonSecondary,
  colorRibbonTextSecondaryDark: tokenRef?.root.colorRibbonSecondaryDark,
  colorDrawerBackgroundOverlay: tokenRef?.root.colorBackgroundOverlay,
  colorDrawerBackgroundStandard: tokenRef?.root.colorBackgroundStandard,
  colorDrawerBackgroundSelected: tokenRef?.root.colorBackgroundSelected,
  colorDrawerBackgroundLabel: tokenRef?.root.colorBackgroundSubtle,
  colorDrawerTextHeader: tokenRef?.root.colorTextNeutral,
  colorDrawerTextHint: tokenRef?.root.colorTextLabel,
  colorDrawerTextTitlePinned: tokenRef?.root.colorTextNeutral,
  colorDrawerTextTitle: tokenRef?.root.colorTextNeutral,
  colorDrawerTextSubtitle: tokenRef?.root.colorTextSubtle,
  colorDrawerTextStrikethrough: tokenRef?.root.colorTextStrikethrough,
  colorDrawerTextLabel: tokenRef?.root.colorTextLabel,
  colorDrawerTextError: tokenRef?.root.colorTextAlert,
  colorDrawerTextLink: tokenRef?.root.colorTextLink,
  colorDrawerIcon: tokenRef?.root.colorIconSubtle,
  colorDrawerHandle: tokenRef?.root.colorIconWeak,
  colorButtonSecondaryBorderInverse: tokenRef?.root.colorBorderCtaInverse,
  colorButtonSecondaryBorder: tokenRef?.root.colorBorderCta,
  colorButtonIconPrimary: tokenRef?.root.colorIconCta,
  colorButtonIconPrimaryInverse: tokenRef?.root.colorIconCtaInverse,
  colorButtonIconSecondaryInverse: tokenRef?.root.colorIconCtaInverse,
  colorButtonIconSecondary: tokenRef?.root.colorIconCta,
  colorButtonIconSuccess: tokenRef?.root.colorIconInverse,
  colorButtonTextPrimary: tokenRef?.root.colorTextCtaInverse,
  colorButtonTextSecondary: tokenRef?.root.colorTextCta,
  colorButtonTextPrimaryInverse: tokenRef?.root.colorTextCta,
  colorButtonTextSecondaryInverse: tokenRef?.root.colorTextCtaInverse,
  colorButtonBackgroundPrimary: tokenRef?.root.colorBackgroundCta,
  colorButtonBackgroundPrimaryInverse: tokenRef?.root.colorBackgroundCtaInverse,
  colorButtonBackgroundPrimaryPressed: tokenRef?.root.colorBackgroundCtaPressed,
  colorButtonBackgroundPrimaryInversePressed: tokenRef?.root.colorBackgroundCtaInversePressed,
  colorButtonBackgroundSuccess: tokenRef?.root.colorBackgroundCtaSuccess,
  colorStickyFooterText: tokenRef?.root.colorTextNeutral,
  colorStickyFooterPrice: tokenRef?.root.colorTextNeutral,
  colorStickyFooterPriceStrikethrough: tokenRef?.root.colorTextStrikethrough,
  colorStickyFooterBorderTop: tokenRef?.root.colorBorderWeak,
  colorStickyFooterBackground: tokenRef?.root.colorBackgroundStandard,
  colorInputBackground: tokenRef?.root.colorBackgroundStandard,
  colorInputBackgroundHaze: tokenRef?.root.colorBackgroundSubtle,
  colorInputBackgroundSelected: tokenRef?.root.colorBackgroundSelected,
  colorInputBackgroundHover: tokenRef?.root.colorBackgroundHover,
  colorInputBorderActive: tokenRef?.root.colorBorderActive,
  colorInputBorderError: tokenRef?.root.colorBorderError,
  colorInputBorderStandard: tokenRef?.root.colorBorderStandard,
  colorInputTextLabel: tokenRef?.root.colorTextNeutral,
  colorInputTextHintMessage: tokenRef?.root.colorTextNeutral,
  colorInputTextLabelActive: tokenRef?.root.colorTextLabel,
  colorInputTextPlaceholder: tokenRef?.root.colorTextLabel,
  colorInputTextActive: tokenRef?.root.colorTextNeutral,
  colorInputTextLink: tokenRef?.root.colorTextLink,
  colorInputTextError: tokenRef?.root.colorTextAlert,
  colorInputTextCounter: tokenRef?.root.colorTextLabel,
  colorInputTextSuccess: tokenRef?.root.colorTextSuccess,
  colorInputTextLoading: tokenRef?.root.colorTextDisabled,
  colorInputTextOptions: tokenRef?.root.colorTextNeutral,
  colorInputTextSearchString: tokenRef?.root.colorTextNeutral,
  colorInputTextNonsearchString: tokenRef?.root.colorTextLabel,
  colorInputTextNumber: tokenRef?.root.colorTextNeutral,
  colorInputTextDocumentName: tokenRef?.root.colorTextNeutral,
  colorInputIconLoader: tokenRef?.root.colorIconLoader,
  colorInputIconSuccess: tokenRef?.root.colorIconSuccess,
  colorInputIconInverse: tokenRef?.root.colorIconInverse,
  colorInputIconBackgroundActive: tokenRef?.root.colorIconCta,
  colorInputIconStandard: tokenRef?.root.colorIconSubtle,
  colorInputIconBackgroundDisabled: tokenRef?.root.colorIconDisabled,
  colorSearchInputBackground: tokenRef?.root.colorBackgroundStandard,
  colorSearchInputBackgroundHaze: tokenRef?.root.colorBackgroundSubtle,
  colorSearchInputBackgroundHover: tokenRef?.root.colorBackgroundHover,
  colorSearchInputBorderActive: tokenRef?.root.colorBorderActive,
  colorSearchInputBorderStandard: tokenRef?.root.colorBorderStandard,
  colorSearchInputTextPlaceholder: tokenRef?.root.colorTextLabel,
  colorSearchInputTextLabel: tokenRef?.root.colorTextLabel,
  colorSearchInputTextActive: tokenRef?.root.colorTextNeutral,
  colorSearchInputTextResults: tokenRef?.root.colorTextNeutral,
  colorSearchInputIconLoader: tokenRef?.root.colorIconLoader,
  colorSearchInputIconStandard: tokenRef?.root.colorIconSubtle,
  colorToggleOn: tokenRef?.root.colorToggleActiveWeak,
  colorToggleBaseActive: tokenRef?.root.colorToggleActiveStrong,
  colorToggleOff: tokenRef?.root.colorToggleInactiveWeak,
  colorToggleBase: tokenRef?.root.colorToggleInactiveStrong,
  colorToggleIndicatorHover: tokenRef?.root.colorToggleIndicator,
  colorRatingText: tokenRef?.root.colorTextLabel,
  colorRatingIconActive: tokenRef?.root.colorIconRating,
  colorRatingIconBase: tokenRef?.root.colorIconDisabled,
  colorCheckboxInputBorderError: tokenRef?.root.colorBorderError,
  colorCheckboxInputBorderStandard: tokenRef?.root.colorBorderStandard,
  colorCheckboxInputBorderHover: tokenRef?.root.colorBorderActive,
  colorCheckboxInputBackgroundStandard: tokenRef?.root.colorBackgroundStandard,
  colorCheckboxInputBackgroundActive: tokenRef?.root.colorBackgroundActive,
  colorRadioInputBackgroundStandard: tokenRef?.root.colorBackgroundStandard,
  colorRadioInputBackgroundActive: tokenRef?.root.colorBackgroundActive,
  colorRadioInputBorderError: tokenRef?.root.colorBorderError,
  colorRadioInputBorderStandard: tokenRef?.root.colorBorderStandard,
  colorRadioInputBorderHover: tokenRef?.root.colorBorderActive,
  colorSelectorBackground: tokenRef?.root.colorBackgroundStandard,
  colorSelectorBackgroundSubtle: tokenRef?.root.colorBackgroundSubtle,
  colorSelectorBorderActive: tokenRef?.root.colorBorderActive,
  colorSelectorBorderStandard: tokenRef?.root.colorBorderStandard,
  colorSelectorBorderDisabled: tokenRef?.root.colorBorderDisabled,
  colorSelectorTextTitle: tokenRef?.root.colorTextNeutral,
  colorSelectorTextBody: tokenRef?.root.colorTextNeutral,
  colorSelectorTextPrice: tokenRef?.root.colorTextNeutral,
  colorSelectorTextSubtitle: tokenRef?.root.colorTextSubtle,
  colorSelectorTextStrikethrough: tokenRef?.root.colorTextStrikethrough,
  colorSelectorTextDisabled: tokenRef?.root.colorTextDisabled,
  colorSelectorTextUnavailable: tokenRef?.root.colorTextNeutral,
  colorSelectorColorIndicatorBorderInner: tokenRef?.root.colorBorderWeak,
  colorSelectorColorIndicatorBorderOuter: tokenRef?.root.colorBorderStandard,
  colorSelectorColorIndicatorStrikeout: tokenRef?.root.colorBorderStrikeout,
  colorSelectorColorIndicatorStrikeoutInverse: tokenRef?.root.colorBorderStrikeoutInverse,
  colorToastTextInverse: tokenRef?.root.colorTextInverse,
  colorToastIconAlert: tokenRef?.root.colorIconAlertInverse,
  colorToastIconSuccess: tokenRef?.root.colorIconSuccess,
  colorToastIconPending: tokenRef?.root.colorIconPending,
  colorToastTextLinkInverse: tokenRef?.root.colorTextLinkInverse,
  colorToastBackground: tokenRef?.root.colorBackgroundDark,
  colorTextLinkText: tokenRef?.root.colorTextLink,
  colorTextLinkTextInverse: tokenRef?.root.colorTextLinkInverse,
  colorTextLinkHeaderStandard: tokenRef?.root.colorTextSubtle,
  colorTextLinkHeaderStandardInverse: tokenRef?.root.colorTextInverse,
  colorTextLinkHeaderHover: tokenRef?.root.colorTextHeaderHighlight,
  colorTextLinkHeaderHoverInverse: tokenRef?.root.colorTextHeaderHighlightInverse,
  colorTextLinkHeaderActive: tokenRef?.root.colorTextHeaderHighlight,
  colorTextLinkHeaderActiveInverse: tokenRef?.root.colorTextHeaderHighlightInverse,
  colorTextLinkHeaderActiveMain: tokenRef?.root.colorTextHeaderActive,
  colorTextLinkIcon: tokenRef?.root.colorIconLink,
  colorTextLinkIconInverse: tokenRef?.root.colorIconLinkInverse,
  colorTagText: tokenRef?.root.colorTextInverse,
  colorTagBackgroundPrimary: tokenRef?.root.colorTagPrimary,
  colorTagBackgroundSecondary: tokenRef?.root.colorTagSecondary,
  colorTabsTextTitle: tokenRef?.root.colorTextLink,
  colorTabsTextTitleInverse: tokenRef?.root.colorTextCtaInverse,
  colorTabsTextSubtitle: tokenRef?.root.colorTextLink,
  colorTabsTextSubtitleInverse: tokenRef?.root.colorTextCtaInverse,
  colorTabsTextTitleInactive: tokenRef?.root.colorTextSubtle,
  colorTabsTextTitleInverseInactive: tokenRef?.root.colorTextSubtleInverse,
  colorTabsTextSubtitleInactive: tokenRef?.root.colorTextSubtle,
  colorTabsTextSubtitleInverseInactive: tokenRef?.root.colorTextSubtleInverse,
  colorTabsBorderActive: tokenRef?.root.colorBorderActive,
  colorTabsBorderActiveInverse: tokenRef?.root.colorBorderActiveInverse,
  colorTabsBorderInactive: tokenRef?.root.colorBorderWeak,
  colorTabsBorderInactiveInverse: tokenRef?.root.colorBorderWeakInverse,
  colorTabsIconActive: tokenRef?.root.colorIconLink,
  colorTabsIconActiveInverse: tokenRef?.root.colorIconCtaInverse,
  colorTabsIconInactive: tokenRef?.root.colorIconSubtle,
  colorTabsIconInactiveInverse: tokenRef?.root.colorIconSubtleInverse,
  colorTableText: tokenRef?.root.colorTextNeutral,
  colorTableBackground: tokenRef?.root.colorBackgroundStandard,
  colorTableCellHover: tokenRef?.root.colorBackgroundHover,
  colorTableCellSelected: tokenRef?.root.colorBackgroundSelected,
  colorStepperTextInactive: tokenRef?.root.colorTextLabel,
  colorStepperTextActive: tokenRef?.root.colorTextInverse,
  colorStepperTextLabel: tokenRef?.root.colorTextSubtle,
  colorStepperBackgroundActive: tokenRef?.root.colorBackgroundActive,
  colorStepperBackgroundInactive: tokenRef?.root.colorIconInactive,
  colorStepperBackgroundSuccess: tokenRef?.root.colorIconActive,
  colorStepperIconSuccess: tokenRef?.root.colorIconInverse,
  colorStepperBorderActive: tokenRef?.root.colorBorderActive,
  colorStepperConnectorSuccess: tokenRef?.root.colorBorderStrong,
  colorStepperConnectorInactive: tokenRef?.root.colorBorderWeak,
  colorPaginationText: tokenRef?.root.colorTextNeutral,
  colorPaginationIcon: tokenRef?.root.colorIconSubtle,
  colorPaginationBackgroundHover: tokenRef?.root.colorBackgroundHover,
  colorNumberedListText: tokenRef?.root.colorTextNeutral,
  colorTopNavigationTitleStandard: tokenRef?.root.colorTextNeutral,
  colorTopNavigationTitleInverse: tokenRef?.root.colorTextInverse,
  colorTopNavigationGradient: tokenRef?.root.colorGradientNeutral,
  colorTopNavigationBackground: tokenRef?.root.colorBackgroundStandard,
  colorTopNavigationBackgroundHaze: tokenRef?.root.colorBackgroundSubtle,
  colorTopNavigationBorderBottom: tokenRef?.root.colorBorderWeak,
  colorBottomNavigationTextActive: tokenRef?.root.colorTextNavigationActive,
  colorBottomNavigationTextInactive: tokenRef?.root.colorTextLabel,
  colorBottomNavigationIconInactive: tokenRef?.root.colorIconBottomNavigationInactive,
  colorBottomNavigationIconActive: tokenRef?.root.colorIconBottomNavigationActive,
  colorBottomNavigationBackground: tokenRef?.root.colorBackgroundStandard,
  colorBottomNavigationBorderTop: tokenRef?.root.colorBorderWeak,
  colorModalTextHeader: tokenRef?.root.colorTextNeutral,
  colorModalTextBody: tokenRef?.root.colorTextNeutral,
  colorModalBackground: tokenRef?.root.colorBackgroundStandard,
  colorModalOverlay: tokenRef?.root.colorBackgroundOverlay,
  colorModalIcon: tokenRef?.root.colorIconNeutral,
  colorLocationPinDefault: tokenRef?.root.colorIconLocationPin,
  colorLocationPinActive: tokenRef?.root.colorIconLocationPinActive,
  colorLocationPinText: tokenRef?.root.colorTextNeutral,
  colorLocationPinTextBorder: tokenRef?.root.colorTextInverse,
  colorListItemBackground: tokenRef?.root.colorBackgroundStandard,
  colorListItemIconBackground: tokenRef?.root.colorBackgroundSubtle,
  colorListItemTextTitle: tokenRef?.root.colorTextNeutral,
  colorListItemTextSubtitle: tokenRef?.root.colorTextSubtle,
  colorListItemTextPoints: tokenRef?.root.colorTextNeutral,
  colorListItemIconSubtle: tokenRef?.root.colorIconSubtle,
  colorListItemIcon: tokenRef?.root.colorIconNeutral,
  colorHeroBannerTextTitle: tokenRef?.root.colorTextNeutral,
  colorHeroBannerTextTitleInverse: tokenRef?.root.colorTextInverse,
  colorHeroBannerTextSubtitle: tokenRef?.root.colorTextNeutral,
  colorHeroBannerTextSubtitleInverse: tokenRef?.root.colorTextInverse,
  colorHeroBannerIndicatorInactive: tokenRef?.root.colorIconInactive,
  colorHeroBannerIndicatorActive: tokenRef?.root.colorIconActive,
  colorCirclePatternTextHeader: tokenRef?.root.colorTextNeutral,
  colorCirclePatternTextTitle: tokenRef?.root.colorTextNeutral,
  colorCirclePatternTextBody: tokenRef?.root.colorTextNeutral,
  colorCarouselTextTitle: tokenRef?.root.colorTextNeutral,
  colorCarouselTextBody: tokenRef?.root.colorTextNeutral,
  colorCarouselTextTitleInverse: tokenRef?.root.colorTextInverse,
  colorCarouselTextBodyInverse: tokenRef?.root.colorTextInverse,
  colorCarouselIndicatorActive: tokenRef?.root.colorIconActive,
  colorCarouselIndicatorInactive: tokenRef?.root.colorIconInactive,
  colorCarouselArrowIcon: tokenRef?.root.colorIconNeutral,
  colorCarouselArrowBackground: tokenRef?.root.colorIconInactive,
  colorCarouselOverlay: tokenRef?.root.colorBackgroundOverlayLight,
  colorBannerBackground: tokenRef?.root.colorBackgroundStandard,
  colorBannerBackgroundLight: tokenRef?.root.colorBackgroundSubtle,
  colorBannerBackgroundDark: tokenRef?.root.colorBackgroundDark2,
  colorBannerTextTitle: tokenRef?.root.colorTextNeutral,
  colorBannerTextBody: tokenRef?.root.colorTextNeutral,
  colorBannerTextTitleInverse: tokenRef?.root.colorTextInverse,
  colorBannerTextBodyInverse: tokenRef?.root.colorTextInverse,
  colorBreadcrumbsTextCurrentPage: tokenRef?.root.colorTextNeutral,
  colorBreadcrumbsTextPages: tokenRef?.root.colorTextLabel,
  colorBreadcrumbsTextTruncation: tokenRef?.root.colorTextLabel,
  colorBreadcrumbsDivider: tokenRef?.root.colorTextLabel,
  colorBulletListText: tokenRef?.root.colorTextNeutral,
  colorBulletListIcon: tokenRef?.root.colorTextNeutral,
  colorAccordionIcon: tokenRef?.root.colorIconSubtle,
  colorAccordionIconInverse: tokenRef?.root.colorIconInverse,
  colorAccordionTextTitle: tokenRef?.root.colorTextNeutral,
  colorAccordionTextTitleInverse: tokenRef?.root.colorTextInverse,
  colorAccordionTextBody: tokenRef?.root.colorTextNeutral,
  colorAccordionTextBodyInverse: tokenRef?.root.colorTextInverse,
  colorCardTextTitle: tokenRef?.root.colorTextNeutral,
  colorCardTextTitleInverse: tokenRef?.root.colorTextInverse,
  colorCardTextSubtitle: tokenRef?.root.colorTextSubtle,
  colorCardTextSubtitleInverse: tokenRef?.root.colorTextInverse,
  colorCardTextBody: tokenRef?.root.colorTextNeutral,
  colorCardTextBodyInverse: tokenRef?.root.colorTextInverse,
  colorCardTextPrice: tokenRef?.root.colorTextSubtle,
  colorCardTextPriceInverse: tokenRef?.root.colorTextSubtleInverse,
  colorCardTextPriceStrikethrough: tokenRef?.root.colorTextStrikethrough,
  colorCardTextPriceStrikethroughInverse: tokenRef?.root.colorTextSubtleInverse,
  colorCardTextLink: tokenRef?.root.colorTextLink,
  colorCardTextHeader: tokenRef?.root.colorTextNeutral,
  colorCardTextHeaderInverse: tokenRef?.root.colorTextInverse,
  colorCardTextSubheader: tokenRef?.root.colorTextSubtle,
  colorCardTextSubheaderInverse: tokenRef?.root.colorTextInverse,
  colorCardTextHeaderDark: tokenRef?.root.colorTextNeutral,
  colorCardIconSubtitle: tokenRef?.root.colorIconSubtle,
  colorCardIconTitle: tokenRef?.root.colorIconNeutral,
  colorCardBackground: tokenRef?.root.colorBackgroundStandard,
  colorCardBackgroundDark: tokenRef?.root.colorBackgroundDark2,
  colorCardOverlay: tokenRef?.root.colorGradientNeutral,
  colorCardOverlayLight: tokenRef?.root.colorBackgroundOverlayLight,
  colorCardBorder: tokenRef?.root.colorBorderWeak,
  colorCardHeaderTitle: tokenRef?.root.colorTextNeutral,
  colorCardHeaderSubtitle: tokenRef?.root.colorTextSubtle,
  colorCalendarTextDay: tokenRef?.root.colorTextNeutral,
  colorCalendarTextMonth: tokenRef?.root.colorTextNeutral,
  colorCalendarTextDate: tokenRef?.root.colorTextNeutral,
  colorCalendarTextDateStrikethrough: tokenRef?.root.colorTextDisabled,
  colorCalendarTextDateSelected: tokenRef?.root.colorTextInverse,
  colorCalendarBackgroundSelected: tokenRef?.root.colorBackgroundActive,
  colorCalendarBackgroundSelectedRange: tokenRef?.root.colorBackgroundSelected,
  colorCalendarBackgroundDay: tokenRef?.root.colorBackgroundSubtle,
  colorCalendarBackgroundHover: tokenRef?.root.colorBackgroundHover,
  colorCalendarIcon: tokenRef?.root.colorIconSubtle,
  colorNotificationTextTitle: tokenRef?.root.colorTextNeutral,
  colorNotificationTextBody: tokenRef?.root.colorTextNeutral,
  colorNotificationBackgroundAlert: tokenRef?.root.colorNotificationAlert,
  colorNotificationBackgroundInfo: tokenRef?.root.colorNotificationDefault,
  colorNotificationBackgroundPromo: tokenRef?.root.colorNotificationPromo,
  colorNotificationIcon: tokenRef?.root.colorIconNeutral,
  colorChipBackgroundStandard: tokenRef?.root.colorBackgroundStandard,
  colorChipBackgroundHover: tokenRef?.root.colorBackgroundHoverNeutral,
  colorChipBackgroundActive: tokenRef?.root.colorBackgroundSelected,
  colorChipBorderActive: tokenRef?.root.colorBorderActive,
  colorChipBorderStandard: tokenRef?.root.colorBorderStandard,
  colorChipTextActive: tokenRef?.root.colorTextNeutral,
  colorChipTextInactive: tokenRef?.root.colorTextSubtle,
  colorChipIcon: tokenRef?.root.colorIconSubtle,
  colorGraphBackgroundActiveStrong: tokenRef?.root.colorBackgroundActive,
  colorGraphBackgroundActiveWeak: tokenRef?.root.colorBackgroundActiveWeak,
  colorGraphBackgroundData: tokenRef?.root.colorBackgroundDark,
  colorGraphBackgroundDataInverse: tokenRef?.root.colorBackgroundStandard,
  colorGraphBackgroundActiveStrongInverse: tokenRef?.root.colorBackgroundActiveInverse,
  colorGraphBackgroundActiveWeakInverse: tokenRef?.root.colorBackgroundActiveWeakInverse,
  colorGraphBorderBenchmark: tokenRef?.root.colorBorderBenchmark,
  colorGraphBorderBenchmarkInverse: tokenRef?.root.colorBorderBenchmarkInverse,
  colorGraphBorderAxis: tokenRef?.root.colorBorderStandard,
  colorGraphBorderGridLine: tokenRef?.root.colorBorderStandard,
  colorGraphTextData: tokenRef?.root.colorTextInverse,
  colorGraphTextDataInverse: tokenRef?.root.colorTextNeutral,
  colorGraphTextAxisLabel: tokenRef?.root.colorTextSubtle,
  colorGraphTextAxisLabelInverse: tokenRef?.root.colorTextSubtleInverse,
  colorCardIconListThumbnailBorder: tokenRef?.root.colorBorderStandard,
  colorCardIconListThumbnailBackground: tokenRef?.root.colorBackgroundSubtle,
  colorIconButtonNeutral: tokenRef?.root.colorIconNeutral,
  colorIconButtonInverse: tokenRef?.root.colorIconInverse,
  colorDateTimePickerTextDay: tokenRef?.root.colorTextNeutral,
  colorDateTimePickerTextDate: tokenRef?.root.colorTextNeutral,
  colorDateTimePickerTextMonth: tokenRef?.root.colorTextNeutral,
  colorDateTimePickerTextDateStrikethrough: tokenRef?.root.colorTextDisabled,
  colorDateTimePickerTextDateSelected: tokenRef?.root.colorTextInverse,
  colorDateTimePickerIcon: tokenRef?.root.colorIconSubtle,
  colorDateTimePickerBorder: tokenRef?.root.colorBorderStandard,
  colorDateTimePickerBackgroundSelected: tokenRef?.root.colorBackgroundActive,
  colorDateTimePickerBackgroundHover: tokenRef?.root.colorBackgroundHover,
  colorHeaderBackground: tokenRef?.root.colorBackgroundHeader,
  colorHeaderBorder: tokenRef?.root.colorBorderWeak,
  colorCardColorListBorder: tokenRef?.root.colorBorderWeak,
  colorFooterBackground: tokenRef?.root.colorBackgroundFooter,
  colorCoachmarkBackground: tokenRef?.root.colorBackgroundCoachmark,
  colorCoachmarkIndicator: tokenRef?.root.colorBackgroundCoachmark,
  colorCoachmarkText: tokenRef?.root.colorTextInverse,
  colorCoachmarkBackgroundCircle: tokenRef?.root.colorBackgroundCtaInverse,
  shadowVoucherLow: tokenRef?.root.shadow1,
  shadowTable: tokenRef?.root.shadowLow,
  shadowToggle: tokenRef?.root.shadowLow,
  shadowTopNavigation: tokenRef?.root.shadowLow,
  shadowListItem: tokenRef?.root.shadowLow,
  shadowCardLow: tokenRef?.root.shadowLow,
  shadowCardHigh: tokenRef?.root.shadowHigh,
  borderWidthInputStandard: tokenRef?.root.borderWidthStandard,
  borderWidthDividerStandard: tokenRef?.root.borderWidthStandard,
  borderWidthSelectorStandard: tokenRef?.root.borderWidthStandard,
  borderWidthSelectorActive: tokenRef?.root.borderWidthSelected,
  borderWidthSelectorStrikeout: tokenRef?.root.borderWidthStrikeout,
  borderWidthTabsStandard: tokenRef?.root.borderWidthSelected,
  borderWidthTabsActive: tokenRef?.root.borderWidthSelected,
  borderWidthStepperActive: tokenRef?.root.borderWidthSelected,
  borderWidthStepperConnector: tokenRef?.root.borderWidthStandard,
  borderWidthButtonSecondary: tokenRef?.root.borderWidthCta,
  borderWidthChip: tokenRef?.root.borderWidthStandard,
  borderRadiusDrawerTopLeft: tokenRef?.root.borderRadiusMd,
  borderRadiusDrawerTopRight: tokenRef?.root.borderRadiusMd,
  borderRadiusButton: tokenRef?.root.borderRadiusXl,
  borderRadiusCarouselFixed: tokenRef?.root.borderRadiusSm,
  borderRadiusInput: tokenRef?.root.borderRadiusSm,
  borderRadiusSearchInput: tokenRef?.root.borderRadiusSm,
  borderRadiusCarouselFixedLg: tokenRef?.root.borderRadiusMd,
  borderRadiusSelector: tokenRef?.root.borderRadiusSm,
  borderRadiusToast: tokenRef?.root.borderRadiusSm,
  borderRadiusTag: tokenRef?.root.borderRadiusSm,
  borderRadiusTable: tokenRef?.root.borderRadiusSm,
  borderRadiusTableLg: tokenRef?.root.borderRadiusMd,
  borderRadiusNotification: tokenRef?.root.borderRadiusSm,
  borderRadiusModal: tokenRef?.root.borderRadiusMd,
  borderRadiusVoucher: tokenRef?.root.borderRadiusSm,
  borderRadiusChip: tokenRef?.root.borderRadiusXl,
  borderRadiusCardSm: tokenRef?.root.borderRadiusSm,
  borderRadiusListItem: tokenRef?.root.borderRadiusSm,
  borderRadiusDatetimepicker: tokenRef?.root.borderRadiusInput,
  borderFileInput: tokenRef?.root.borderUpload,
  opacitySelectorTextDisabled: tokenRef?.root.opacityDisabled,
  opacitySelectorImageDisabled: tokenRef?.root.opacityDisabled,
  colorBackgroundDisabled: tokenRef?.root.opacityOverlay,
  colorDivider10Horizontal: tokenRef?.root.colorDivider,
  colorDivider10Text: tokenRef?.root.colorTextSubtle,
  opacityButtonHover: tokenRef?.root.opacityHover,
  opacityButtonPressed: tokenRef?.root.opacityPressed,
});
const tokenKey = key => getComponentToken()[key] || '';
const designTokenKey = key => tokenRef?.root[key] || '';

const TokenManager = {
  tokenKey,
  designTokenKey,
  setTokenRef,
  getComponentToken,
};
export default TokenManager;
